var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":"https://img1.baidu.com/it/u=2662682505,1738248369&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500","alt":"404"}}),_c('router-link',{staticClass:"back-btn",attrs:{"to":"/article"}},[_vm._v("return")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }